import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';
import { useAuthStore } from '@/store/auth';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Middlewar
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const guestOnly = to.matched.some(record => record.meta.guestOnly);
  const requiredRoles = to.matched.flatMap(record => record.meta.requiredRoles || []);
  const requiredPermissions = to.matched.flatMap(record => record.meta.requiredPermissions || []);

  console.log('to: ', to);
  console.log('requiresAuth: ', requiresAuth);
  console.log('guestOnly: ', guestOnly);
  console.log('isAuthenticated: ', authStore.isAuthenticated());
  console.log('requiredRoles: ', requiredRoles);
  console.log('requiredPermissions: ', requiredPermissions);
  console.log('hasPermissions: ', authStore.permissions);

  if (requiresAuth && !authStore.isAuthenticated()) { //Auth needed, but the user is not authenticated
    console.log('router: requiresAuth && !authStore.isAuthenticated()');
    next('/auth/login');
    return;
  }

  if (guestOnly && authStore.isAuthenticated()) { //Guest only, but the user is authenticated
    console.log('router: guestOnly && authStore.isAuthenticated()');
    next('/');
    return;
  }

  // Проверка по ролям
  if (requiredRoles.length > 0 && !requiredRoles.some(role => authStore.roles.includes(role))) {
    console.log('access denied: roles');
    next('/'); // например, на главную или 403 страницу
    return;
  }

  // Проверка по permissions
  if (requiredPermissions.length > 0 && !requiredPermissions.some(permission => authStore.permissions.includes(permission))) {
    console.log('access denied: permissions');
    next('/'); // например, на главную или 403 страницу
    return;
  }
  console.log('next(): ');
  next();
});
export default router;
